/**
 * API services for Nhanh.vn integration.
 */

export const fetchDepotsApi = async ({ appId, businessId, accessToken }) => {
  const url = `https://pos.open.nhanh.vn/v3.0/business/depot?appId=${appId}&businessId=${businessId}`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchProductsApi = async ({
  appId,
  businessId,
  accessToken,
  page = 1,
  size = 1000,
  nextId = null,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/product/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      paginator: {
        size: size,
        ...(nextId ? { next: { id: nextId } } : { page: page }),
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchOrdersApi = async ({
  appId,
  businessId,
  accessToken,
  fromDate,
  toDate,
  statuses,
  saleChannels,
  page = 1,
  size = 1000,
  nextId = null,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/order/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filters: {
        createdAtFrom: fromDate || "",
        createdAtTo: toDate || "",
        ...(statuses && statuses.length > 0 ? { statuses } : {}),
        ...(saleChannels && saleChannels.length > 0 ? { saleChannels } : {}),
      },
      paginator: {
        size: size,
        ...(nextId ? { next: { id: nextId } } : { page: page }),
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchBillsApi = async ({
  appId,
  businessId,
  accessToken,
  fromDate,
  toDate,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/bill/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken || "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filters: {
        fromDate: fromDate || "",
        toDate: toDate || "",
        modes: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchInvoicesApi = async ({
  appId,
  businessId,
  accessToken,
  fromDate,
  toDate,
  page = 1,
  size = 100,
  nextId = null,
}) => {
  const url = `https://pos.open.nhanh.vn/v3.0/invoice/list?appId=${appId}&businessId=${businessId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: accessToken || "",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      filters: {
        ...(fromDate ? { issueFromDate: fromDate } : {}),
        ...(toDate ? { issueToDate: toDate } : {}),
      },
      paginator: {
        size: size,
        ...(nextId ? { next: { id: nextId } } : { page: page }),
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

